import _ from 'lodash';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Layout from '@/components/layout'
import PartnerTemplate from '@/components/partners/PartnerTemplate';
import PartnerPlaceholder from '@/components/partners/PartnerPlaceholder';
import { getAllPartners } from '@/lib/partners';
import { sortBy } from '@/helpers/HelperFunctions';


export default function Partners({ partners, locale }) {
  // Check if props are present
  if (!partners) {
    return null;
  }

  const { t } = useTranslation('partners');

  const displayPartners = (partnerList) => {
    if (!partnerList) return null;

    return partnerList.map((partner, index) =>
      <PartnerTemplate partner={partner} locale={locale} key={index} />
    );
  };

  return (
    <Layout title={t('partner')}>
      <div className="header bg-white">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="my-5">
                <h1 className="display-4">{t('partner')}</h1>
                <p>
                  Unser Partnernetzwerk bringt die Top-Anbieter von Analyse- und Workflow-Technologien zusammen und öffnet neue Dimensionen im Krankenhausmanagement. Durch unsere KIS-unabhängigen IT-Softwareanbieter und spezialisierten Beratungsfirmen bietet HYAPP ein breites Feld an Leistungs- und Funktionsbereichen, Kosten- und Erlösanalysen sowie Prozess- und Steuerungsinstrumenten im Krankenhaus an.<br />
                  <br />
                  Gespeist aus einem gemeinsamen Datenpool, kann Ihr Klinikcontrolling durch den Einsatz von intelligenten Analyseinstrumenten schneller und präziser alle steuerungsrelevanten Kennzahlen ermitteln. Mühsames Sammeln und Verarbeiten von Daten aus Einzelsystemen entfällt.<br />
                  <br />
                  Unser Anspruch ist es, Ihnen die bestmögliche Auswahl an BI-Lösungen führender Anbieter zur Verfügung zu stellen. Weitere qualifizierte Partner werden dabei sukzessive folgen.<br />
                  <br />
                  Erfahren Sie mehr über unsere Partner!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {displayPartners(partners)}
        </div>
      </div>
    </Layout>
  )
}

export async function getStaticProps({ locale }) {
  let partners = await getAllPartners();

  partners = _.map(partners, (partner) => {
    delete partner.apps;
    return partner;
  });

  // Alphabetical order
  partners.sort(sortBy('name'));

  return {
    // will be passed to the page component as props
    props: {
      partners,
      locale,
      ...await serverSideTranslations(locale, ['common', 'menu', 'partners'])
    },
    revalidate: 1
  }
}